export const config = (<any>window).PB_FRAGMENT_COMMON_CONFIG
  ? JSON.parse((<any>window).PB_FRAGMENT_COMMON_CONFIG)
  : process.env;
